import { Component, Input, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { TabItemComponent } from '@Components';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.css',
})
export class TabsComponent implements AfterContentInit {
  activeTab = 0;
  @Input() tabsNames = ['One', 'Two', 'Three'];

  @ContentChildren(TabItemComponent) tabItems!: QueryList<TabItemComponent>;

  ngAfterContentInit(): void {
    this.updateActiveTabItems();
  }

  selectTab(index: number): void {
    this.activeTab = index;
    this.updateActiveTabItems();
  }

  private updateActiveTabItems(): void {
    if (this.tabItems) {
      this.tabItems.forEach((item, i) => {
        item.active = i === this.activeTab;
      });
    }
  }
}
